import { Box } from "../../../../../../mads";

import { spacing } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

/**
 * Renders a generic video embed using a native iframe element (web).
 */
export function GenericVideoEmbed({ videoUrl }: { videoUrl: string }) {
  return (
    <Box sx={styles.videoContainer}>
      <iframe
        src={videoUrl}
        style={{ width: "100%", height: "100%", border: "none" }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </Box>
  );
}

const styles = StyleSheet.create({
  videoContainer: {
    width: "100%",
    aspectRatio: 16 / 9,
    marginVertical: spacing.s3,
  },
});
